module.exports = __webpack_public_path__ + "static/success-02623b7c54a4ed5c74405345bc22961b.svg";